import { render } from "./BuekOrderIframe.vue?vue&type=template&id=01a83430&ts=true"
import script from "./BuekOrderIframe.ts?vue&type=script&lang=ts&external"
export * from "./BuekOrderIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__